$(".mobile-see-more").each(function () {

    let button = $(this).find('.mobile-see-more-toggle'),
        contents = $(this).find('.mobile-see-more-contents');

    button.on('click', function () {
        if($(window).width() < 992) {
            if($(this).hasClass('is-open')) {
                $(this).removeClass('is-open');
                $(this).text('Read more...');
                contents.slideUp();
            } else {
                $(this).addClass('is-open');
                $(this).text('Read less');
                contents.slideDown();
            }
        }
    });

});
